import { useTranslation } from 'react-i18next';
// import { add, differenceInSeconds } from 'date-fns';
import { Title2, P3 } from "@components/new/Typo";
import { Modal, ModalSize } from "@components/new/Modal";
// import { ButtonType } from "@components/new/Button";
import {
  TWarehouse,
} from "@api/apiClient/fbp";
import styles from "./WarehouseInfoModal.module.scss";

interface WarehouseInfoModalProps {
  onClose: () => void;
  warehouseInfo?: TWarehouse;
}

const WarehouseInfoModal = ({ onClose, warehouseInfo }: WarehouseInfoModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={true}
      title={(warehouseInfo?.name ?? "")}
      size={ModalSize.M}
      onClose={onClose}
      footerButtons={[
        {
          // type: ButtonType.PRIMARY,
          title: t("fbpPage.warehouseInfoModal.cancelBtn"),
        },
      ]}
    >
      <div className={styles.section}>
        <Title2 color="grey-800">
          {t('fbpPage.warehouseInfoModal.address')}
        </Title2>
        <P3>{warehouseInfo?.address}</P3>
      </div>
      {warehouseInfo?.openingHours ? (
        <div className={styles.section}>
          <Title2 color="grey-800">
            {t('fbpPage.warehouseInfoModal.openingHours')}
          </Title2>
          <P3>{warehouseInfo?.openingHours}</P3>
        </div>
      ) : null}
    </Modal>
  )
}

export default WarehouseInfoModal;
